import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { PostHogProvider} from 'posthog-js/react'

const options = {
  api_host: "https://us.i.posthog.com",
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  {/* <React.StrictMode> */}
  <PostHogProvider 
      apiKey="phc_PsnyQsx7c41FforOqHHVStRBLvmP5ck7X7PjsNAOgn2"
      options={options}
    >
    <App />
    </PostHogProvider>
  {/* </React.StrictMode> */}
  </BrowserRouter>
);

reportWebVitals();
